import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { HeroBanner } from "../../components/banner/HeroBanner";
import bgLeftImage from "./../../assets/images/bg-left.svg";
import bgRightImage from "./../../assets/images/bg-right.svg";
import "./AdminDashboard.scss";
import "./ListingPage.scss";
import { TILES, SUB_TILES_MAP, SubTileConfig } from "./tileConfig";

export const ListingPage = () => {
    const location = useLocation();
    const history = useHistory();

    const tileMatch = TILES.find(t => t.route === location.pathname);
    const bannerTitle = tileMatch?.name || '';
    const bannerDesc = tileMatch?.subtitle || '';
    const bannerLogo = tileMatch?.imgsrcListingPage;

    const handleBackClick = () => {
        history.push("/");
    };

    const handleTileClick = (route: string) => {
        const newWindow = window.open(route, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };

    const handleTileKeyDown = (e: React.KeyboardEvent, route: string) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleTileClick(route);
        }
    };

    const currentTileList = tileMatch && tileMatch.route ? SUB_TILES_MAP[tileMatch.route] || [] : [];

    return (
        <div className="app-dashboard-container">
            <HeroBanner
                title={`Welcome To ${bannerTitle}`}
                desc={bannerDesc}
                mainLogoSrc={bannerLogo}
                showBackButton={true}
                onBackClick={handleBackClick}
            />
            <div className="list-tile-container">
                {currentTileList.length > 0 ? (
                    currentTileList.map((tile: SubTileConfig) => (
                    <div
                        key={tile.id}
                        className="list-tile-item"
                        role="article"
                        aria-labelledby={`tile-title-${tile.id}`}
                        aria-describedby={`tile-desc-${tile.id}`}
                    >
                        {tile.iconSrc && (
                            <div className="list-tile-icon" aria-hidden="true">
                                <img src={tile.iconSrc} alt="" />
                            </div>
                        )}
                        <div className="list-tile-content">
                            <h2 id={`tile-title-${tile.id}`} className="list-tile-title">
                                {tile.title}
                            </h2>
                            <p id={`tile-desc-${tile.id}`} className="list-tile-desc">{tile.desc}</p>
                        </div>
                        {tile.route && (
                            <button
                                className="list-tile-button"
                                onClick={() => handleTileClick(tile.route!)}
                                onKeyDown={(e) => handleTileKeyDown(e, tile.route!)}
                                aria-label={`Get started with ${tile.title}`}
                                type="button"
                            >
                                GET STARTED
                            </button>
                        )}
                    </div>
                    ))
                ) : (
                    <div className="list-tile-empty-state">
                        <p>No items available at this time.</p>
                    </div>
                )}
            </div>
            <div className="dashboard-background-images">
                <img src={bgLeftImage} alt="Background Left" className="bg-left" />
                <img src={bgRightImage} alt="Background Right" className="bg-right" />
            </div>
        </div>
    );
}